/**
 * URL base de la API de este proyecto.
 * Por defecto usa el mismo origen (www.delfuocampo.com en producción).
 * VITE_API_URL solo para desarrollo local (proxy a vercel dev).
 */
export function getApiBaseUrl(): string {
  const env = import.meta.env.VITE_API_URL as string | undefined;
  if (env && typeof env === "string" && env.trim()) {
    return env.trim().replace(/\/+$/, "");
  }
  return typeof window !== "undefined" ? window.location.origin : "";
}

/** True si VITE_API_URL está definida (override explícito para dev). */
export function isApiUrlConfigured(): boolean {
  const env = import.meta.env.VITE_API_URL as string | undefined;
  return !!(env && typeof env === "string" && env.trim());
}